import React from "react";
import { RotatingLoadingIcon } from "./styled/loading-indicator";

function LoadingIndicator() {
  return <RotatingLoadingIcon />;
}

export default LoadingIndicator;
